<template>
  <cy-drawer title="添加/编辑" v-model="visible" :loading="loading" @cancel="cancel" @confirm="submit('form')" width="70%">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-alert :message="$t('基本信息')" type="success" />
      <a-row :gutter="10">
        <a-col
          :lg="4"
        ><a-form-model-item
          :label="$t('图片')"
          prop="mainImg"
        >
          <file-upload ref="upload" @change="uploadChange('mainImg', $event)"></file-upload>
        </a-form-model-item
        ></a-col>
        <a-col
          :lg="4"
        ><a-form-model-item
          :label="$t('视频')"
          prop="video"
        >
          <FileUploadVideo @change="uploadChange('video', $event)" />
          <!-- <a-button v-if="form.video" type="link" @click="openVideo()">{{ $t('查看视频') }} </a-button> -->
          <video v-if="form.video" :src="form.video" style="width: 100px; height: 100px; margin-top: 4px;" controls></video>
          <div>Please upload mp4 file</div>
        </a-form-model-item
        ></a-col>
        <a-col
          :lg="16"
        ><a-form-model-item
          :label="$t('菜谱标题')"
          prop="title"
        ><a-input v-model="form.title" :placeholder="$t('请输入')"></a-input></a-form-model-item
        ></a-col>
        <a-col
          :lg="6"
        ><a-form-model-item
          :label="$t('菜谱所属分类')"
          prop="classifyId"
        >
          <a-select v-model="form.classifyId" :placeholder="$t('请选择')">
            <a-select-option v-for="item in fenleiList" :key="item.id" :value="item.id">{{ item.classifyName }}</a-select-option>
          </a-select>
        </a-form-model-item
        ></a-col>
        <a-col
          :lg="12"
        ><a-form-model-item
          :label="$t('难易程度')"
          prop="level"
        >
          <a-radio-group v-model="form.level">
            <a-radio :value="1">{{ $t('简单') }}</a-radio>
            <a-radio :value="2">{{ $t('普通') }}</a-radio>
            <a-radio :value="3">{{ $t('高级') }}</a-radio>
          </a-radio-group>
        </a-form-model-item
        ></a-col>
        <a-col
          :lg="24"
        ><a-form-model-item
          :label="$t('菜谱描述')"
          prop="content"
        ><a-textarea v-model="form.content" :placeholder="$t('请输入')"></a-textarea></a-form-model-item
        ></a-col>

      </a-row>
      <a-alert :message="$t('配料信息')" type="info" />
      <a-row :gutter="10">
        <a-col
          :lg="8"
        >
          <div class="flex align-center" v-for="(item,index) in form.ingredients" :key="`zhuliao-${index}`">
            <a-form-model-item
              :label="index==0?$t('主料名称'):''"
              :prop="`ingredients.${index}.name`"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              :label="index==0?$t('用量'):''"
              :prop="`ingredients.${index}.content`"
              style="margin-left: 10px;"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              prop="remark"
              style="margin-left: 10px;"
              v-if="form.ingredients.length>1"
            ><a-button :style="{marginTop: index==0?'40px':''}" type="primary" shape="circle" icon="minus" @click="handleDel('ingredients', index)" /></a-form-model-item
            >
          </div>
          <a-form-model-item style="width: 100%;">

            <a-button type="dashed" style="width: 100%;" @click="handleAdd('ingredients', { name: '', content: '' })">{{ $t('添加') }}</a-button>
          </a-form-model-item>

        </a-col>
        <a-col
          :lg="8"
        >
          <div class="flex align-center" v-for="(item,index) in form.excipients" :key="`fuliao-${index}`">
            <a-form-model-item
              :label="index==0?$t('辅料名称'):''"
              :prop="`excipients.${index}.name`"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              :label="index==0?$t('用量'):''"
              :prop="`excipients.${index}.content`"
              style="margin-left: 10px;"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              prop="remark"
              style="margin-left: 10px;"
              v-if="form.excipients.length>1"
            ><a-button :style="{marginTop: index==0?'40px':''}" type="primary" shape="circle" icon="minus" @click="handleDel('excipients', index)" /></a-form-model-item
            >
          </div>
          <a-form-model-item style="width: 100%;">

            <a-button type="dashed" style="width: 100%;" @click="handleAdd('excipients', { name: '', content: '' })">{{ $t('添加') }}</a-button>
          </a-form-model-item>
        </a-col>
        <a-col
          :lg="8"
        >
          <div class="flex align-center" v-for="(item,index) in form.condiment" :key="`tiaoliao-${index}`">
            <a-form-model-item
              :label="index==0?$t('调料名称'):''"
              :prop="`condiment.${index}.name`"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              :label="index==0?$t('用量'):''"
              :prop="`condiment.${index}.content`"
              style="margin-left: 10px;"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              prop="remark"
              style="margin-left: 10px;"
              v-if="form.condiment.length>1"
            ><a-button :style="{marginTop: index==0?'40px':''}" type="primary" shape="circle" icon="minus" @click="handleDel('condiment', index)" /></a-form-model-item
            >
          </div>
          <a-form-model-item style="width: 100%;">
            <a-button type="dashed" style="width: 100%;" @click="handleAdd('condiment', { name: '', content: '' })">{{ $t('添加') }}</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-alert :message="$t('做法步骤')" type="info" />
      <a-row :gutter="10" v-for="(item,index) in form.stepAddParamList" :key="`zuofa-${index}`">
        <!-- <a-col
          :lg="4"
        ><a-form-model-item
          :label="index==0?$t('图片'):''"
          :prop="`stepAddParamList.${index}.img`"
          :rules="{required: false, message: $t('请上传图片')}"
        >
          <file-upload :ref="`stepAddParamList${index}`" @change="handleSetpUpload(index, $event)"></file-upload>
        </a-form-model-item
        >
        </a-col> -->
        <a-col
          :lg="20"
        ><a-form-model-item
          :label="index==0?$t('内容'):''"
          :prop="`stepAddParamList.${index}.content`"
          :rules="{required: true, message: $t('请输入')}"
        >
          <div class="flex align-center">
            <a-textarea rows="1" v-model="item.content" :placeholder="$t('请输入')" :maxLength="255"></a-textarea>
            <a-button
              v-if="form.stepAddParamList.length>1"
              class="flex-shrink"
              style="margin-left: 10px;"
              type="primary"
              shape="circle"
              icon="minus"
              @click="handleDel('stepAddParamList', index)"
            ></a-button>
          </div>
        </a-form-model-item
        >
        </a-col>
      </a-row>
      <a-button
        type="dashed"
        style="width: 100%;"
        @click="handleAdd('stepAddParamList', {
          'content': '',
          'img': '',
          'remark': '',
          'sort': form.stepAddParamList[form.stepAddParamList.length-1].sort+1,
        })">{{ $t('添加') }}</a-button>
    </a-form-model>
  </cy-drawer>
</template>
<script>
import CyDrawer from '@/components/CyDarwer'
import { mapGetters } from 'vuex'
import { addObj, putObj, getObj } from '../api'
import { fetchList } from '@/views/program/repice-category/api'
export default {
  // 组件名称
  name: 'CreateForm',
  // 过滤器
  filters: {},
  // 组件
  components: {
    CyDrawer,
    FileUpload: () => import('@/components/FileUpload/index2'),
    FileUploadVideo: () => import('@/components/FileUpload/indexVideo')
  },
  // props类型
  props: {
    model: {
      type: Object,
      default: () => null
    }
  },
  // 数据

  data() {
    return {
      visible: false,
      loading: false,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      URL: process.env.VUE_APP_API_BASE_URL + '/api/common/upload',
      baseurl: process.env.VUE_APP_API_BASE_URL,
      imgList: [],
      form: {
        'classifyId': undefined,
        'condiment': [
          { name: '', content: '' }
        ],
        'content': '',
        'excipients': [
          { name: '', content: '' }
        ],
        'id': 0,
        'ingredients': [
          { name: '', content: '' }
        ],
        'level': 1,
        'mainImg': '',
        'remark': '',
        'stepAddParamList': [
          {
            'content': '',
            'img': '',
            'remark': '',
            'sort': 0
          }
        ],
        'summarized': '',
        'title': '',
        video: ''
      },
      rules: {
        classifyId: [{ required: true, message: this.$t('请选择') }],
        title: [{ required: true, message: this.$t('请输入') }],
        mainImg: [{ required: true, message: this.$t('请上传封面图') }],
        content: [{ required: true, message: this.$t('请输入菜谱描述') }]
      },
      editFlag: true,
      select: {
        provinceId: null,
        cityId: null,
        areaId: null
      },
      fenleiList: []
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['roleList'])
  },
  // 计算属性监听
  watch: {},
  // 创建时
  created() {
    this.getFenleiList()
  },
  // 挂载完毕
  mounted() {},
  // 方法
  methods: {
    openVideo() {
      window.open(this.form.video, '_blank')
    },
    getFenleiList() {
      fetchList({ pageNum: 1, pageSize: 2 ** 31 - 1 }).then(res => {
        console.log(res)
        this.fenleiList = res.data.records
      })
    },
    handleDel(key, index) {
      this.form[key].splice(index, 1)
      this.$forceUpdate()
      setTimeout(() => {
        if (key === 'stepAddParamList') {
          this.form.stepAddParamList.map((item, index) => {
            this.$refs[`stepAddParamList${index}`].init({
              fileExplainName: item.img,
              filePath: item.img,
              fileId: item.img
            }, 782, 483)
          })
        }
      }, 0)
    },
    handleAdd(key, obj) {
      this.form[key].push(JSON.parse(JSON.stringify(obj)))
    },
    uploadChange(key, e) {
      console.log('===', key, e)
      this.form[key] = e ? e.url : undefined
    },
    handleSetpUpload(index, e) {
      this.form.stepAddParamList[index].img = e ? e.url : undefined
    },
    editorChange(e) {
      console.log(e)
      if (e === '<p><br></p>') {
        this.form.content = ''
      } else {
        this.form.content = e
      }
    },
    handleUploadChange(values) {
      console.log(values)
      this.form.iamTypeNum = values.length > 1 ? 2 : 1
      this.form.iamgePaths = values.map((item) => item.shortcutUrl).join(',')
    },
    del(index) {
      this.form.propDrops.splice(index, 1)
    },
    addDomain() {
      const obj = {
        propNum: undefined,
        num: 0,
        infeRate: 0
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.propDrops.push(JSON.parse(JSON.stringify(obj)))
        }
      })
    },
    init(id) {
      if (id) this.form.id = id
      this.visible = true
      this.$nextTick(() => {
        console.log(this.$refs)

        if (id) {
          this.loading = true
          getObj(this.form.id).then((res) => {
            const keyArr = ['condiment', 'excipients', 'ingredients']
            this.form = res.data
            this.$refs.upload.init(this.form.mainImg ? {
              fileExplainName: this.form.mainImg,
              filePath: this.form.mainImg,
              fileId: this.form.id
            } : '', 782, 483)
            for (const key in this.form) {
              if (keyArr.includes(key)) {
                this.form[key] = JSON.parse(this.form[key])
              }
            }
            this.form.stepAddParamList = this.form.stepResultList
            setTimeout(() => {
              this.form.stepAddParamList.map((item, index) => {
                this.$refs[`stepAddParamList${index}`][0].init({
                  fileExplainName: item.img,
                  filePath: item.img,
                  fileId: item.img
                }, 782, 483)
              })
            }, 0)

            console.log(this.form)
          }).finally(() => {
            this.loading = false
          })
        } else {
          console.log('初始化图片')
          setTimeout(() => {
            this.$refs.upload.init('', 782, 483)
          }, 600)
        }
      })
    },
    cancel() {
      this.visible = false
      this.$emit('close')
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          const from = JSON.parse(JSON.stringify(this.form))
          const keyArr = ['condiment', 'excipients', 'ingredients']
          for (const key in from) {
            if (keyArr.includes(key)) {
              from[key] = JSON.stringify(from[key])
            }
          }
          console.log(from)
          if (from.id) {
            putObj({ ...from })
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            addObj({ ...from })
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          }
        }
      })
    },
    handlecoverPicList(e) {
      console.log(e)
      if (e.length > 0) {
        this.form.avatar = e[0].url
      }
    },
    change() {},
    selected(e) {
      console.log(e)
      this.form.province = e.province.value
      this.form.city = e.city.value
      this.form.area = e.area.value
    }
  }
}
</script>

<style lang="less" scoped>
.amap-demo {
  height: 300px;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.daoju {
  position: relative;
  .del {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
